import GameSignals from '@/signals/GameSignals'
import { BaseState } from '@/stateMachine/BaseState'
import { GameStatesEnum } from '@/states/GameStatesEnum'

export class LoadingState extends BaseState {
    public begin() {
        GameSignals.loadAssetsComplete.connect(this.end)
        GameSignals.loadAssets.emit()
    }

    public end = () => {
        this._stateMachine.setState(GameStatesEnum.INIT_STATE)
    }

    public cleanUp() {
        GameSignals.loadAssetsComplete.disconnect(this.end)
    }
}
